import { reactive } from 'vue';

export const store = reactive({
  formCliente: {},
  formObjeto: {},
  formProduto: {},
  formFaturamento: {},
  formInformacoes: {},
  currentTab: 0,
  isUpdate: false,
  pafNFCe: false,
  apresentarObjetoIdentificador: false,
  configuracaoCarregada: false,
});
